/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type BlobStorageExportFrequency = "hourly" | "daily" | "weekly";
export const BlobStorageExportFrequency = {
  Hourly: "hourly",
  Daily: "daily",
  Weekly: "weekly",
} as const;
